import {
  Box,
  ParagraphText,
  StackLayout,
  TextAction,
} from "@leagueplatform/genesis-core";
import { AppleStoreLink } from "components/app-store-links/apple-store-link.component";
import { GoogleStoreLink } from "components/app-store-links/google-store-link.component";

export const AppFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      as="footer"
      css={{
        width: "100%",
        padding: "$twoAndHalf $three",
        borderTop: "1px solid $onSurfaceBorderSubdued",
        backgroundColor: "$surfaceBackgroundTertiary",
        "@mobileLandscape": {
          padding: "$two $oneAndHalf",
        },
        "@mobile": {
          padding: "$two $oneAndHalf",
        },
      }}
    >
      <StackLayout
        orientation={{
          "@initial": "horizontal",
          "@mobileLandscape": "vertical",
          "@mobile": "vertical",
        }}
        horizontalAlignment="spaceBetween"
        verticalAlignment="top"
        css={{ gap: "40px", maxWidth: "1200px", marginInline: "auto" }}
      >
        <StackLayout
          orientation="vertical"
          css={{
            gap: "$one",
            flex: "0 0 auto",
            height: "auto",
            width: "fit-content",
            alignItems: "flex-start",
          }}
        >
          <AppleStoreLink />
          <GoogleStoreLink />
        </StackLayout>

        <StackLayout
          orientation="vertical"
          css={{ gap: "$oneAndHalf", flex: 1, alignItems: "flex-start" }}
        >
          <StackLayout
            orientation="horizontal"
            css={{ gap: "$two", flexWrap: "wrap" }}
          >
            <TextAction
              as="a"
              href="https://www.emblemhealth.com/legal/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              indicator="externalLink"
            >
              Privacy Policy
            </TextAction>
            <TextAction
              as="a"
              href="https://www.emblemhealth.com/legal/digital-services-privacy-policy-and-terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
              indicator="externalLink"
            >
              Terms of Service
            </TextAction>
          </StackLayout>
          <ParagraphText size="xs" css={{ color: "$onSurfaceTextSubdued" }}>
            © {currentYear} Emblem Health
          </ParagraphText>
        </StackLayout>
      </StackLayout>
    </Box>
  );
};
